export enum TranskodeSubtitleFormatEnum {
  STL = "STL",
  PAC = "PAC",
  TTML = "TTML",
  SCC = "SCC",
  ITT = "ITT",
  STL_CLOSED = "STL_CLOSED",
  DFXP = "DFXP",
  CAP = "CAP",
  SRT = "SRT",
  VTT = "VTT",
  CAP_VTRON = "CAP_VTRON",
  _ASINPUT = "_ASINPUT",
  _UNKNOWN = "_UNKNOWN",
  PDF = "PDF",
  DOC = "DOC",
  DOCX = "DOCX",
  TXT = "TXT",
  RTF = "RTF",
}
